var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"relative m-auto chart"},[_c('chart',{attrs:{"data":_vm.data,"options":_vm.options,"height":200}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }